import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOSchema from '@/components/feature/SEOSchema';

export default function DisclaimerPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOSchema
        type="page"
        title="Disclaimer - KakobuySheet Kakobuy Spreadsheet Shopping Resource"
        description="KakobuySheet Disclaimer. Understand the limitations, external link policies, shopping risks, and affiliate disclosures for our Kakobuy Spreadsheet directory."
        url="https://kakobuy.boutique/disclaimer"
        dateModified="2026-06-25"
      />
      <Navbar />
      <main className="pt-24 pb-16 md:pt-28 md:pb-20">
        <div className="max-w-[900px] mx-auto px-6 md:px-10">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
            <Link to="/" className="hover:text-primary-600 transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700 font-medium">Disclaimer</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">Disclaimer</h1>
          <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed text-base md:text-lg">
            <p>The information provided on KakobuySheet is for general informational purposes only. While we strive to keep our <strong>Kakobuy Spreadsheet</strong> directory accurate and up to date, we make no representations or warranties of any kind about the completeness, accuracy, or reliability of the information, products, or services referenced through our external links.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">External Links Disclaimer</h2>
            <p>Our website links to external sites, primarily kaspreadsheet.com, for <strong>Kakobuy Spreadsheet</strong> resources. We do not control, endorse, or assume responsibility for the content, products, services, or practices of any third-party websites. Users should conduct their own due diligence before making any purchases.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Shopping Disclaimer</h2>
            <p>Cross-border shopping involves inherent risks including but not limited to customs delays, product quality variations, and seller reliability. We provide safety tips and community-verified resources as a service, but users are ultimately responsible for their own purchasing decisions. Always research sellers independently and use secure payment methods.</p>
            <h2 className="text-2xl font-heading font-bold text-foreground-950 mt-8 mb-4">Affiliate Disclaimer</h2>
            <p>KakobuySheet may contain affiliate links. This means we may earn a small commission at no additional cost to you when you make a purchase through certain links. This does not affect our commitment to providing accurate and helpful <strong>Kakobuy Spreadsheet</strong> resources.</p>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm">
              <i className="ri-arrow-left-line"></i> Back to Home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}